import { render, staticRenderFns } from "./star-trek.vue?vue&type=template&id=86150a86&scoped=true&"
import script from "./star-trek.vue?vue&type=script&lang=js&"
export * from "./star-trek.vue?vue&type=script&lang=js&"
import style0 from "./star-trek.vue?vue&type=style&index=0&id=86150a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86150a86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86150a86')) {
      api.createRecord('86150a86', component.options)
    } else {
      api.reload('86150a86', component.options)
    }
    module.hot.accept("./star-trek.vue?vue&type=template&id=86150a86&scoped=true&", function () {
      api.rerender('86150a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/star-trek.vue"
export default component.exports